<template>
  <v-card>
    <v-card-title class="pb-0">
      <v-form ref="titleForm" class="grow" v-model="titleFormIsValid">
        <sl-text-field
          :rules="titleRules"
          textarea
          v-model="workspace.name"
          :readonly="userAccess != 'admin'"
          label="Title"
          name="title"
          type="text"
          class="title"
          required
          color="secondary"
          @focus="onTitleEditing"
          @update="titleUpdate"
        />
      </v-form>
      <v-spacer></v-spacer>
      <span class="mt-n8 text-right">
        <div class="text-overline text-center">{{ $t(`workspaceUserAccess.${userAccess}`) }}</div>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" v-bind="attrs" v-on="on" icon @click="goToDashboard">
              <v-icon>mdi-view-dashboard</v-icon>
              <!-- Possibile icona alternativa
               <v-icon>mdi-arrow-top-right</v-icon> -->
            </v-btn>
          </template>
          <span>Go to the dashboard</span>
        </v-tooltip>
        <!-- FIXME: l'OR che disabilita la cancellazione dei workspace privati va bene soltanto fintanto che non si potranno creare nuovi WS privati, poi va raffinato. -->
        <sl-btn-delete
          :disabled="userAccess !== 'admin' || userAccess === 'private'"
          objectType="workspace"
          :object="workspace"
        />
      </span>
    </v-card-title>

    <div class="grey lighten-4 pb-0 px-5 text-left text-overline">Members</div>
    <div class="grey lighten-4 pt-0 pa-4">
      <!---->
      <workspace-users :userAccess="userAccess" :workspace="workspace" />
      <!---->
    </div>
  </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import Logger from '@/lib/Logger'

import Workspace from '@/models/Workspace'

import SlTextField from '@/components/SlTextField'
import SlBtnDelete from '@/components/SlBtnDelete'
import WorkspaceUsers from '@/components/WorkspaceUsers'

export default {
  props: {
    userAccess: {
      type: String,
      required: true,
      validator: function(value) {
        // The value must match one of these strings
        return ['private', 'admin', 'member'].indexOf(value) !== -1
      },
    },
    workspace: {
      type: Object,
      required: true,
    },
  },

  components: {
    SlTextField,
    SlBtnDelete,
    WorkspaceUsers,
  },

  data: () => ({
    titleFormIsValid: true,
    titleRules: [v => !!v || 'Required', v => (v && v.length <= 96) || 'Max 96 characters'],
    titleBackup: '',
    //
  }),

  computed: {
    //
  },

  methods: {
    //
    /* onClick() {
      Logger.debug('Doing something!')
    }, */
    goToDashboard() {
      this.$router.push({ name: 'Dashboard', params: { workspaceId: this.workspace.id } })
    },
    onTitleEditing() {
      this.titleBackup = this.workspace.name
    },
    async titleUpdate() {
      if (this.workspace.name !== this.titleBackup) {
        if (this.titleFormIsValid) {
          try {
            await Workspace.save(this.workspace)
            this.titleBackup = this.workspace.name
            Logger.debug('titleUpdate', this.workspace.id, this.workspace.name)
          } catch (e) {
            this.workspace.name = this.titleBackup
            Logger.error(e)
            this.toastSet({
              message: 'Error in updating workspace name',
              color: 'error',
            })
          }
        } else {
          this.workspace.name = this.titleBackup
          this.toastSet({
            message: 'Error in title text validation, restoring previous title',
            color: 'error',
          })
        }
      }
    },
    /*     userAccessToLabel(accessType) {
      const labels = {
        private: 'Private',
        admin: 'Shared',
        member: 'Invited',
      }
      return labels[accessType]
    }, */
    ...mapMutations(['toastSet']),
  },
}
</script>

<style scoped></style>
